import type { PortalSession } from "../auth/session.js";

/** Habilitacion administrativa; las fechas operativas requieren otro contrato con zona IANA. */
export interface SiteAccess {
  readonly siteId: string;
  readonly name: string;
  readonly providerId: string;
}

export interface AdminSessionContext {
  readonly role: "provider_operator";
  readonly sites: readonly SiteAccess[];
}

export interface SitesPort {
  list(session: PortalSession): Promise<AdminSessionContext>;
}

/** Sin cuerpo remoto: la UI solo distingue rechazo de acceso y error recuperable. */
export class SitesAccessError extends Error {}
